

import { MwcSafeAny } from 'mwc/core/types';

export function isPromise<T>(obj: MwcSafeAny): obj is Promise<T> {
  return !!obj && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
